import apiClient from "../apiClient";
import { API_ENDPOINTS } from "../config";

const communicationLogService = {
  // Get all communication logs
  getCommunicationLogs: async (params = {}) => {
    try {
      
      const queryString = new URLSearchParams(params).toString();
      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.LIST}?${queryString}`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get communication log by ID
  getCommunicationLogById: async (id) => {
    try {
      
      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.GET(id)}`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get communication log by ID (alias for consistency)
  getCommunicationLog: async (id) => {
    return communicationLogService.getCommunicationLogById(id);
  },

  // Create new communication log
  createCommunicationLog: async (data) => {
    try {
      

      const response = await apiClient.post(
        API_ENDPOINTS.COMMUNICATION_LOGS.CREATE,
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Update communication log
  updateCommunicationLog: async (id, data) => {
    try {
      
      const response = await apiClient.put(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.UPDATE(id)}`,
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete communication log
  deleteCommunicationLog: async (id) => {
    try {
      
      const response = await apiClient.delete(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.DELETE(id)}`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Reply to communication
  replyToCommunication: async (id, data) => {
    try {
      
      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.REPLY(id)}`,
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Forward communication
  forwardCommunication: async (id, data) => {
    try {
      
      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.FORWARD(id)}`,
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Export communication logs
  exportCommunicationLogs: async (params = {}) => {
    try {
      
      const queryString = new URLSearchParams(params).toString();
      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.EXPORT}?${queryString}`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get communication statistics
  getCommunicationStats: async () => {
    try {
      
      const response = await apiClient.get(
        API_ENDPOINTS.COMMUNICATION_LOGS.STATS
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Reply to communication log
  replyToCommunicationLog: async (id, data) => {
    try {
      
      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.REPLY(id)}`,
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },
  // Upload attachment to Cloudinary
  uploadAttachment: async (file) => {
    try {
      
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folder", "communication-attachments");

      const response = await apiClient.post(
        API_ENDPOINTS.UPLOAD.CLOUDINARY,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete attachment from Cloudinary
  deleteAttachment: async (publicId, resourceType = "raw") => {
    try {
      
      const response = await apiClient.delete(
        `${API_ENDPOINTS.UPLOAD.DELETE}?public_id=${publicId}&resource_type=${resourceType}`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Send bulk email via background worker
  sendBulkEmail: async (data) => {
    try {
      
      const response = await apiClient.post(
        "/communication-logs/bulk-email",
        data
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Export a single communication detail as Excel (.xlsx)
  exportCommunicationDetail: async (communicationId, fallbackName = 'Communication') => {
    try {
      if (!communicationId) {
        return { success: false, error: 'Communication ID is required' };
      }

      const response = await apiClient.get(
        `/communication-logs/${communicationId}/export`,
        { responseType: 'blob' }
      );

      const sanitized = String(fallbackName || 'Communication')
        .replace(/[\\/:*?"<>|]/g, '')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 80) || 'Communication';
      const filename = `Communication_${sanitized}.xlsx`;

      const objectUrl = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to export communication details'
      };
    }
  },
};

export default communicationLogService;
